<template>
  <v-main> 
    <!-- 라우터에 의해 각페이지를 보여줌 -->      
    <div id="core-view">
      <!-- <div id="Top"> -->
        <v-fade-transition mode="out-in">
          <router-view> 
          </router-view>
        </v-fade-transition>
      <!-- </div> -->
      <CoreFooter v-if="isLogin"/>
    </div>
  </v-main>
</template>

<script>
import CoreFooter from "@/components/core/Footer.vue";
import {mapState} from "vuex";
import EventBus from '@/eventBus.js';

export default {
  computed: {
    ...mapState(["isLogin"]),        
  },

  components: {         
    CoreFooter,        
  },

  mounted () {
    // EventBus.$on("onScrollIdView", (sPath) => {
    // EventBus.$on("onScrollIdView", () => {
    //   setTimeout(() => {
    //     var element = document.getElementById('Top');
    //     element.scrollIntoView({behavior : "smooth"})
    //   }, 300);
    // });
    // EventBus.$on("onScrollIdView", (sPath) => {
    //   var element = document.getElementById(sPath);
    //   element.scrollIntoView({behavior : "smooth"})
    // });
  },

  beforeDestroy(){
    EventBus.$off('onScrollIdView');
  },
}
</script>

<style>
#core-view {
  padding-top: 0px;
  padding-bottom: 0px; 
}

</style>
